module.exports = __webpack_public_path__ + "media/images/logo-dae1c68bbc4f77d56b3b0dfde1325a11.png";